import React, { useState, useRef } from 'react'
import { Modal, Button, Form, ProgressBar, Alert } from 'react-bootstrap'
import axios from 'axios'

const AddMaterial = ({ course_id, show, handleClose }) => {
  const [file, setFile] = useState(null)
  const [fileType, setFileType] = useState('pdf') // Default file type
  const [uploadProgress, setUploadProgress] = useState(0)
  const [errorMessage, setErrorMessage] = useState('')
  const [isUploading, setIsUploading] = useState(false)

  const fileInputRef = useRef(null) // Create a ref for the file input

  const token = localStorage.getItem('jwttoken')

  const allowedTypes = ['pdf', 'docx', 'ppt', 'mp4']
  const maxFileSize = 10 * 1024 * 1024 // 10MB

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0]
    if (selectedFile) {
      const extension = selectedFile.name.split('.').pop().toLowerCase()
      if (!allowedTypes.includes(extension)) {
        setErrorMessage(
          'Invalid file type. Allowed types: PDF, DOCX, PPT, MP4.'
        )
        setFile(null)
        return
      }
      if (selectedFile.size > maxFileSize) {
        setErrorMessage('File size exceeds the 10MB limit.')
        setFile(null)
        return
      }
      setErrorMessage('')
      setFile(selectedFile)
      setFileType(extension) 
    }
  } 

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleDrop = (e) => {
    e.preventDefault()
    const droppedFile = e.dataTransfer.files[0]
    if (droppedFile) {
      const extension = droppedFile.name.split('.').pop().toLowerCase()
      if (!allowedTypes.includes(extension)) {
        setErrorMessage(
          'Invalid file type. Allowed types: PDF, DOCX, PPT, MP4.'
        )
        setFile(null)
        return
      }
      if (droppedFile.size > maxFileSize) {
        setErrorMessage('File size exceeds the 10MB limit.')
        setFile(null)
        return
      }
      setErrorMessage('')
      setFile(droppedFile)
      setFileType(extension) 
    }
  }

  const handleDropZoneClick = () => {
    fileInputRef.current.click() // Trigger click on the hidden file input
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!file) {
      setErrorMessage('Please select a file.')
      return
    }

    setIsUploading(true)
    const reader = new FileReader()
    reader.onloadend = async () => {
      const dataUrl = reader.result

      const formData = {
        file_name: file.name,
        file_type: fileType,
        data: dataUrl,
      }

      try {
        await axios.put(
          `https://tdtlworld.com/dss-kaas-backend/lms/courses/${course_id}/materials/`,
          formData,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              )
              setUploadProgress(percentCompleted)
            },
          }
        )
        alert('File uploaded successfully')
        handleClose()
      } catch (error) {
        console.error('Error uploading file', error)
        setErrorMessage('Failed to upload file.')
      } finally {
        setIsUploading(false)
        setUploadProgress(0)
      }
    }

    reader.readAsDataURL(file)
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Upload Material</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
          <div
            className='drop-zone mb-3'
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            onClick={handleDropZoneClick} // Add click handler
            style={{
              border: '2px dashed #007bff',
              borderRadius: '5px',
              padding: '20px',
              textAlign: 'center',
              cursor: 'pointer',
              backgroundColor: '#f8f9fa',
            }}
          >
            {file ? (
              <p className='text-success'>
                Selected file: <strong>{file.name}</strong>
              </p>
            ) : (
              <p className='text-muted'>
                Drag and drop a file here or click to select
              </p>
            )}
          </div>
          <Form.Control
            ref={fileInputRef} // Attach the ref
            type='file'
            onChange={handleFileChange}
            accept='.pdf,.docx,.ppt,.mp4'
            style={{ display: 'none' }}
          />
          <Form.Group controlId='fileType' className='mt-3'>
            <Form.Label>File Type</Form.Label>
            <Form.Control
              as='select'
              value={fileType}
              onChange={(e) => setFileType(e.target.value)}
            >
              <option value='pdf'>PDF</option>
              <option value='docx'>DOCX</option>
              <option value='ppt'>PPT</option>
              <option value='mp4'>MP4</option>
            </Form.Control>
          </Form.Group>
          {isUploading && (
            <ProgressBar
              animated
              now={uploadProgress}
              label={`${uploadProgress}%`}
              className='mt-3'
            />
          )}
          <Button
            className='mt-3'
            variant='primary'
            type='submit'
            disabled={isUploading}
          >
            {isUploading ? 'Uploading...' : 'Upload'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default AddMaterial
